import React from 'react'
import PropTypes from 'prop-types';

import './modal.styl'
class ModalPanel extends React.Component {
    static propTypes = {
        children: PropTypes.array.isRequired
    }

    render() {
        const {children=[]} = this.props;
        let {node, className} = this.props;
        className = className ? " " + className : ""

        return <div className={"modal"}>
            <div className="modal-background"></div>
            <div className={"modal-panel" + className}>
                {children}
            </div>
        </div>
    }
}

export default ModalPanel

